'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

// vim: set et sw=2 ts=2 sts=2 ff=unix fenc=utf8:
// Author: Kuan Huang<kuan.huang@import.io>
// Created on 2016-12-01

var ActionMutationObserver = function () {
  function ActionMutationObserver() {
    _classCallCheck(this, ActionMutationObserver);
    this.document = null;
    this.observer = null;
    this.mutations = [];
    this._blackList = {
      attributes: new Set(),
      characterData: new Set(),
      childList: new Set()
    };
  }
  _createClass(ActionMutationObserver, [{
    key: 'observe',
    value: function observe(target, options) {
      var _this = this;
      if (this.observer) {
        this.disconnect();
      }
      this.target = target;
      this.options = options;
      this.document = this.target.ownerDocument || this.target;
      this.observer = new this.document.defaultView.MutationObserver(function (mutations) {
        var _mutations;
        (_mutations = _this.mutations).push.apply(_mutations, _toConsumableArray(mutations.filter(function (m) {
          return !_this.isBlackList(m);
        })));
      });
      this.observer.observe(target, options);
    }
  }, {
    key: 'disconnect',
    value: function disconnect() {
      this.observer.disconnect();
      this.observer = null;
      this.document = null;
      this.target = null;
    }
  }, {
    key: 'takeRecords',
    value: function takeRecords() {
      var mutations = this.mutations;
      this.mutations = [];
      return mutations;
    }
  }, {
    key: 'blackListRecords',
    value: function blackListRecords(mutations) {
      var _this2 = this;
      if (mutations === undefined) {
        mutations = this.mutations;
      }
      mutations.forEach(function (mutation) {
        _this2._blackList[mutation.type].add(mutation.target);
      });
    }
  }, {
    key: 'isBlackList',
    value: function isBlackList(mutation) {
      return this._blackList[mutation.type].has(mutation.target);
    }

    /**
     * grouping mutation targets and find actively mutate common parent of targets
     *
     * @param {MutationRecords} mutations
     * @return {Element} most active region
     */
  }, {
    key: 'getMostActiveRegion',
    value: function getMostActiveRegion(mutations) {
      var _this3 = this;
      var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.6;
      if (mutations.length == 0) return;
      var containedMutations = Symbol('mutations');
      var toCleanElements = [];
      mutations.forEach(function (mutation) {
        var parent = mutation.target;
        if (parent.nodeType != Node.ELEMENT_NODE) {
          parent = mutation.parentElement;
        }
        while (parent) {
          if (parent[containedMutations] === undefined) {
            parent[containedMutations] = [];
            toCleanElements.push(parent);
          }
          parent[containedMutations].push(mutation);
          if (parent === _this3.target) {
            break;
          }
          parent = parent.parentElement;
        }
      });
      var base = this.target.nodeType == Node.DOCUMENT_NODE ? this.target.body : this.target;
      if (!base || !base[containedMutations]) return;
      var mostActiveRegion = base;
      var changed = true;
      while (mostActiveRegion && changed) {
        changed = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
          for (var _iterator = mostActiveRegion.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var child = _step.value;
            if (child[containedMutations] && child[containedMutations].length > threshold * base[containedMutations].length && child[containedMutations].length >= mostActiveRegion[containedMutations].length) {
              mostActiveRegion = child;
              changed = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      // clean
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;
      try {
        for (var _iterator2 = toCleanElements[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var element = _step2.value;
          delete element[containedMutations];
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
      return mostActiveRegion;
    }
  }]);
  return ActionMutationObserver;
}();
ActionMutationObserver.displayName = 'ActionMutationObserver';
exports.default = ActionMutationObserver;